<template>
	<section class="intro">
		<h1 class="font-serif">{{ intros[$route.name].title }}</h1>
		<p class="font-sans" v-html="intros[$route.name].description"></p>
	</section>
</template>

<script>
	export default {
		name: 'Intro',
		data() {
			return {
				intros: {
					home: {
						title: 'DCP',
						description: 'Deadbolt Community Patch',
					},
					about: {
						title: 'About',
						description: 'FAQs and feature details for DCP',
					},
					character: {
						title: 'Character',
						description: 'Play as any other NPC, with their own stats and weapons.',
					},
					weapons: {
						title: 'Weapons',
						description: `Choose your <span class="color-g">primary</span> (<span class="color-g">LMB</span>) and <span class="color-b">secondary</span> (<span class="color-b">RMB</span>) weapons.<br>You can use the same weapon for <span class="color-or">both</span>.`,
					},
					abilities: {
						title: 'Abilities',
						description: 'See which actions your character can perform.',
					},
					weather: {
						title: 'Weather',
						description: 'Set different weather effects.',
					},
					settings: {
						title: 'Settings',
						description: 'Configure this app.',
					},
					output: {
						title: 'JSON Result',
						description: 'The final custom.json file contents.',
					},
					guides: {
						title: 'Guides',
						description: 'How to install and use DCP'
					},
				},
			}
		},
		computed: {
			pageDescription()
			{
				return this.pageDescriptions[ this.$route.name ];
			},
		},
	}
</script>

<style lang="scss" scoped>
	.intro {
		text-align: center;
		margin: 40px auto 40px;

		h1 {
			margin-bottom: 5px;
		}

		p {
			font-size: 1.2rem;
		}
	}
</style>